module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1"
  }, [_c('span', [_vm._v("Blurb")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Mary Callahan doesn’t remember Glenncailty, or the handsome Michael Baker, yet she’s connected to both by a dark and dangerous past.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Returning to Ireland for the first time since she was a baby, Mary sets out to learn more about her parents who died in a car bombing, and the rural Irish town where she was born. Her first night at the Glenncailty Castle hotel is full of magic when she stumbles into the pub and meets Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Wary of her sudden and intense feelings for him, she tries to keep Michael at arm’s length even as he introduces her to people who knew her parents. But there are dark forces at play in the castle, and Mary can’t shake the feeling that she’s being watched by someone…or something. When confronted by the past, she must decide if she’s willing to risk her heart for a chance at love and a place to call home.")]), _vm._v(" "), _c('h2', {
    staticClass: "P_Heading_2"
  }, [_c('span', [_vm._v("Previously Published")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("(2013) Farm Boy Press")]), _vm._v(" "), _c('h2', {
    staticClass: "P_Heading_2"
  }, [_c('span', [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Cover Artist: Valerie Tibbs, Tibbs Design")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 63
// module chunks = 0